(function () {
  'use strict';

  var cfg = window.algoliaConfig;
  if (!cfg || !cfg.app_id || !cfg.search_api_key) return;

  var indexName = (cfg.index_prefix || 'shopify_') + 'products';
  var EXCLUDED_TAGS = ['tag_module_item', 'add-on', '100% damage protection', 'membership'];
  var EXCLUDED_TITLE_PATTERNS = ['customize product'];

  // Shopify Algolia stores merchant tags on `tags`. `_tags` is Algolia's
  // internal id/product/variant markers — filtering on it excludes nothing.
  function buildExclusionFilters() {
    var parts = ['inventory_available:true'];
    EXCLUDED_TAGS.forEach(function (tag) {
      parts.push('NOT tags:"' + tag + '"');
    });
    return parts.join(' AND ');
  }

  function formatPrice(amount) {
    if (amount == null || amount === '') return '';
    if (window.Shopify && typeof Shopify.formatPresentmentPrice === 'function') {
      return Shopify.formatPresentmentPrice(amount);
    }
    var n = parseFloat(amount);
    if (isNaN(n)) return '';
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function getQueryFromURL() {
    var params = new URLSearchParams(window.location.search);
    return params.get('q') || '';
  }

  function waitForLibraries(cb) {
    var checks = 0;
    var interval = setInterval(function () {
      checks++;
      if (window.instantsearch && window.algoliasearch) {
        clearInterval(interval);
        cb();
      } else if (checks > 100) {
        clearInterval(interval);
      }
    }, 50);
  }

  function init() {
    var container = document.getElementById('algolia-instantsearch');
    if (!container) return;

    var query = getQueryFromURL();
    var searchClient = algoliasearch(cfg.app_id, cfg.search_api_key);

    // Shared identity + analytics gating (snippets/algolia-config.liquid).
    // Falls back to identity only if the snippet is missing, so the page
    // degrades to the previous behaviour rather than losing queryIDs.
    var analyticsParams = typeof window.rsAlgoliaSearchParams === 'function'
      ? window.rsAlgoliaSearchParams('results-page')
      : (typeof window.rsAlgoliaUser === 'function' ? window.rsAlgoliaUser() : {});

    var search = instantsearch({
      indexName: indexName,
      searchClient: searchClient,
      // An empty query is not a search. Clearing the box on this page fired a
      // tracked "" search (measured on live), and "" was the single
      // highest-volume query in Analytics: 4,653 tracked searches in the 30
      // days to 17 Sep at 2.3% CTR, dragging every account-wide metric down.
      // Keep the request so the grid still renders, but do not count it —
      // and mirror the automation gate so a bot typing into the box stays
      // uncounted too.
      //
      // Not helper.setQueryParameter(): every helper-level setter runs
      // state.resetPage() first, which sent page 2 back to page 1 on each
      // click and the client cache then swallowed the duplicate request.
      // Modify the SearchParameters object directly and override without a
      // change event — the 'search' event carries the modified state through.
      //
      // analytics only — clickAnalytics stays as configure() set it. Turning
      // it off for the empty query left hits without __queryID, and
      // InstantSearch has no clickedObjectIDs fallback: every click on those
      // hits went out as clickedObjectIDsAfterSearch with queryID undefined
      // and positions set, which Insights rejects with 422 (measured on
      // staging, 2026-09-18). clickAnalytics adds no analytics data on its
      // own, so a queryID on an untracked search is harmless.
      searchFunction: function (helper) {
        var track = !!helper.state.query && analyticsParams.analytics !== false;
        var state = helper.state.setQueryParameter('analytics', track);
        // analyticsParams (and its analyticsTags) is captured once at init.
        // Re-read tags onto this same state object on every request so
        // traffic:suspect is absent from the next query after the flag
        // clears. helper.setQueryParameter would reset the page.
        if (typeof window.rsAlgoliaSearchParams === 'function') {
          var liveParams = window.rsAlgoliaSearchParams('results-page');
          if (liveParams && liveParams.analyticsTags) {
            state = state.setQueryParameter('analyticsTags', liveParams.analyticsTags);
          }
        }
        helper.overrideStateWithoutTriggeringChangeEvent(state).search();
      },
      routing: {
        stateMapping: {
          stateToRoute: function (uiState) {
            var is = uiState[indexName] || {};
            return {
              q: is.query || '',
              page: is.page,
              sort: is.sortBy,
              type: is.refinementList && is.refinementList.product_type,
              tags: is.refinementList && is.refinementList.tags
            };
          },
          routeToState: function (routeState) {
            var s = {};
            s[indexName] = {
              query: routeState.q || '',
              page: routeState.page,
              sortBy: routeState.sort,
              refinementList: {}
            };
            if (routeState.type) s[indexName].refinementList.product_type = routeState.type;
            if (routeState.tags) s[indexName].refinementList.tags = routeState.tags;
            return s;
          }
        }
      },
      // Off for automation: with insights:true InstantSearch loads its own
      // copy of search-insights when window.aa is missing, so skipping the
      // boot in theme.liquid alone still let view and click events through.
      insights: analyticsParams.analytics !== false,
      initialUiState: (function () {
        var s = {};
        s[indexName] = { query: query };
        return s;
      })()
    });

    var widgets = instantsearch.widgets;

    search.addWidgets([
      widgets.searchBox({
        container: '#algolia-is-searchbox',
        placeholder: 'Search products...',
        showSubmit: true,
        showReset: true,
        cssClasses: {
          input: 'algolia-is__search-input',
          form: 'algolia-is__search-form'
        }
      }),

      widgets.stats({
        container: '#algolia-is-stats',
        templates: {
          text: function (data) {
            if (!data.query) return data.nbHits.toLocaleString() + ' products';
            if (data.nbHits === 0) return 'No results for \u201c' + data.query + '\u201d';
            return data.nbHits.toLocaleString() + ' results for \u201c' + data.query + '\u201d';
          }
        }
      }),

      widgets.sortBy({
        container: '#algolia-is-sort',
        items: [
          { label: 'Relevance', value: indexName }
          // Add replicas here once created in Algolia Dashboard:
          // { label: 'Price: Low to High', value: indexName + '_price_asc' },
          // { label: 'Price: High to Low', value: indexName + '_price_desc' }
        ]
      }),

      // userToken has to ride on the search itself, not just the Insights
      // events, or Algolia counts a new user per request. The automation
      // gate in analyticsParams overrides clickAnalytics; the empty-query
      // case is handled per request in searchFunction above.
      widgets.configure(Object.assign({
        filters: buildExclusionFilters(),
        hitsPerPage: 24,
        clickAnalytics: true
      }, analyticsParams)),

      widgets.refinementList({
        container: '#algolia-is-facet-type',
        attribute: 'product_type',
        limit: 8,
        showMore: true,
        showMoreLimit: 30,
        searchable: true,
        searchablePlaceholder: 'Search categories...',
        transformItems: function (items) {
          return items.map(function (item) {
            var parts = item.label.split(' > ');
            return Object.assign({}, item, {
              label: parts[parts.length - 1],
              highlighted: parts[parts.length - 1]
            });
          });
        }
      }),

      widgets.refinementList({
        container: '#algolia-is-facet-tags',
        attribute: 'tags',
        limit: 10,
        showMore: true,
        showMoreLimit: 50,
        searchable: true,
        searchablePlaceholder: 'Search tags...',
        transformItems: function (items) {
          return items.filter(function (item) {
            var v = item.value.toLowerCase();
            if (v === 'not on discount' || v === 'baselayer' || v === 'salenotapplying' || v === 'addb2b') return false;
            for (var i = 0; i < EXCLUDED_TAGS.length; i++) {
              if (v === EXCLUDED_TAGS[i].toLowerCase()) return false;
            }
            return true;
          });
        }
      }),

      widgets.rangeInput({
        container: '#algolia-is-facet-price',
        attribute: 'price'
      }),

      widgets.currentRefinements({
        container: '#algolia-is-current',
        transformItems: function (items) {
          return items.filter(function (item) {
            return item.attribute !== 'inventory_available';
          });
        }
      }),

      widgets.clearRefinements({
        container: '#algolia-is-clear',
        templates: {
          resetLabel: 'Clear all filters'
        }
      }),

      widgets.hits({
        container: '#algolia-is-hits',
        cssClasses: {
          root: 'algolia-is__hits'
        },
        templates: {
          item: function (hit, bindEvent) {
            var title = hit.title || '';
            for (var i = 0; i < EXCLUDED_TITLE_PATTERNS.length; i++) {
              if (title.toLowerCase().indexOf(EXCLUDED_TITLE_PATTERNS[i]) !== -1) return '';
            }

            var image = hit.image || hit.product_image || '';
            var handle = hit.handle || '';
            var url = '/products/' + handle;
            var vendor = hit.vendor || '';
            var price = parseFloat(hit.variants_min_price || hit.price);
            var compare = parseFloat(hit.compare_at_price);
            var onSale = compare && compare > price;
            // Build Your Own configurators index with a $0 base variant (the
            // real price is assembled on the PDP). A "$0.00" card is wrong, so
            // those hits render without a price line; every other product
            // carries a positive price and is unaffected. Owner call 2026-09-23.
            var hasPrice = price > 0;
            // Shoplift price testing: tag JS-rendered prices so the Shoplift
            // script can swap them for visitors in a test variant. Product-level
            // Algolia records use the product ID as objectID; `id` covers
            // variant-level records.
            var slPid = hit.id || hit.objectID || '';
            var slP = slPid ? ' data-sl-attribute-p="' + slPid + '"' : '';
            var slCap = slPid ? ' data-sl-attribute-cap="' + slPid + '"' : '';

            // The queryID rides on the card itself. InstantSearch stamps
            // hit.__queryID per result; reading it back from the clicked
            // element attributes the click to the search that produced that
            // card, even after the query has changed underneath it.
            var html = '<a class="algolia-is-card" href="' + url + '"' +
              ' data-objectid="' + (hit.objectID || '') + '"' +
              ' data-queryid="' + (hit.__queryID || '') + '"' +
              ' data-productid="' + (hit.id || '') + '" ' +
              bindEvent('click', hit, 'Product Clicked') + '>';
            html += '<div class="algolia-is-card__image">';
            if (image) {
              html += '<img src="' + image + '" alt="' + title.replace(/"/g, '&quot;') + '" loading="lazy" width="300" height="300" />';
            }
            html += '</div>';
            if (vendor) {
              html += '<p class="algolia-is-card__vendor">' + vendor + '</p>';
            }
            html += '<p class="algolia-is-card__title">' + instantsearch.highlight({ attribute: 'title', hit: hit }) + '</p>';
            if (hasPrice) {
              html += '<p class="algolia-is-card__price">';
              if (onSale) {
                // Mirror snippets/price.liquid semantics: name each price for
                // screen readers instead of two bare numbers (WCAG 1.3.1).
                html += '<span class="visually-hidden">Sale price </span>';
                html += '<span class="algolia-is-card__price--sale"' + slP + '>' + formatPrice(price) + '</span>';
                html += '<span class="visually-hidden"> Regular price </span>';
                html += '<span class="algolia-is-card__price--compare"' + slCap + '>' + formatPrice(compare) + '</span>';
              } else {
                html += '<span' + slP + '>' + formatPrice(price) + '</span>';
              }
              html += '</p>';
            }
            html += '</a>';
            return html;
          },
          empty: function (results) {
            var q = results.query || '';
            return '<div class="algolia-is__no-results">' +
              '<h2>No products found</h2>' +
              '<p>We couldn\u2019t find any products matching \u201c' + q + '\u201d. Try a different search term.</p>' +
              '</div>';
          }
        }
      }),

      widgets.pagination({
        container: '#algolia-is-pagination',
        padding: 2,
        showFirst: true,
        showLast: true,
        scrollTo: '#algolia-instantsearch'
      })
    ]);

    // rangeInput renders its number fields without labels, and may re-create
    // them on any render.
    search.on('render', function () {
      var priceFacet = document.getElementById('algolia-is-facet-price');
      if (!priceFacet) return;
      var min = priceFacet.querySelector('.ais-RangeInput-input--min');
      var max = priceFacet.querySelector('.ais-RangeInput-input--max');
      if (min) min.setAttribute('aria-label', 'Minimum price');
      if (max) max.setAttribute('aria-label', 'Maximum price');
    });

    search.start();

    // Attribution for the add-to-cart that happens on the PDP, read by
    // assets/algolia-insights.js. The queryID comes from the card
    // (data-queryid), not from a page-level variable: the previous
    // `search.helper.on('result')` listener never fired — InstantSearch v4
    // emits results on the derived helper — so the results page had never
    // written this record, and the main search surface had produced zero
    // conversions and zero purchase attribution (measured 2026-09-18).
    container.addEventListener('click', function (e) {
      var card = e.target.closest('.algolia-is-card');
      if (!card) return;
      var objectID = card.getAttribute('data-objectid');
      var queryID = card.getAttribute('data-queryid');
      if (!objectID || !queryID || !window.rsAlgoliaAttribution) return;
      window.rsAlgoliaAttribution.remember({
        objectID: objectID,
        queryID: queryID,
        productId: card.getAttribute('data-productid') || '',
        indexName: indexName,
        source: 'search'
      });
    });

    var pageContainer = container.closest('.container') || container.parentElement;
    if (pageContainer) {
      pageContainer.classList.add('algolia-is-active');
    }

    var filterToggle = document.querySelector('.algolia-is__filter-toggle');
    var sidebar = document.querySelector('.algolia-is__sidebar');
    var overlay = document.querySelector('.algolia-is__sidebar-overlay');
    var closeBtn = document.querySelector('.algolia-is__sidebar-close-btn');

    // The sidebar is a static column on desktop but a modal overlay on mobile
    // (it only opens via the filter toggle, which is mobile-only). Apply dialog
    // semantics + focus management while open, and remove them on close so the
    // desktop layout is unaffected (WCAG 2.1.2, 2.4.3, 4.1.2).
    var lastFocusedBeforeFilters = null;
    var filterKeydownHandler = null;

    function focusableIn(el) {
      return Array.prototype.slice.call(el.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (n) { return n.offsetWidth > 0 || n.offsetHeight > 0; });
    }

    function openFilters() {
      if (!sidebar) return;
      lastFocusedBeforeFilters = document.activeElement;
      sidebar.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      sidebar.setAttribute('role', 'dialog');
      sidebar.setAttribute('aria-modal', 'true');
      sidebar.setAttribute('aria-labelledby', 'algolia-filters-title');
      if (filterToggle) filterToggle.setAttribute('aria-expanded', 'true');

      (closeBtn || sidebar).focus();

      filterKeydownHandler = function (e) {
        if (e.key === 'Escape') { e.preventDefault(); closeFilters(); return; }
        if (e.key !== 'Tab') return;
        var f = focusableIn(sidebar);
        if (!f.length) return;
        var first = f[0];
        var last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      };
      document.addEventListener('keydown', filterKeydownHandler);
    }

    function closeFilters() {
      if (sidebar) {
        sidebar.classList.remove('is-open');
        sidebar.removeAttribute('role');
        sidebar.removeAttribute('aria-modal');
        sidebar.removeAttribute('aria-labelledby');
      }
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false');

      if (filterKeydownHandler) {
        document.removeEventListener('keydown', filterKeydownHandler);
        filterKeydownHandler = null;
      }
      // Return focus to the control that opened the dialog (WAI dialog
      // pattern); fall back to whatever had focus before opening.
      var returnTarget = filterToggle
        || (lastFocusedBeforeFilters && lastFocusedBeforeFilters.focus ? lastFocusedBeforeFilters : null);
      if (returnTarget && typeof returnTarget.focus === 'function') returnTarget.focus();
      lastFocusedBeforeFilters = null;
    }

    if (filterToggle) filterToggle.addEventListener('click', openFilters);
    if (closeBtn) closeBtn.addEventListener('click', closeFilters);
    if (overlay) overlay.addEventListener('click', closeFilters);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { waitForLibraries(init); });
  } else {
    waitForLibraries(init);
  }
})();
